module.exports = __webpack_public_path__ + "img/spirit_Image_one.0ac619c0.png";